"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _index = require("../index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _accordion_styles = _interopRequireDefault(require("./accordion_styles"));

var _accordion_definition = _interopRequireDefault(require("./accordion_definition"));

var _definecomponent = require("../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
/* ========== ~~~~~~~~~~ EXPORT : ACCORDION ~~~~~~~~~~ ========== */


var Accordion = (0, _reactJss.default)(_accordion_styles.default)(function (props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var handleActiveState = function handleActiveState() {
    return setActive(active ? false : true);
  };

  var handleLink = function handleLink(e) {
    return props.handleLink ? props.handleLink(e, isActive()) : handleActiveState();
  };

  var handleToggle = function handleToggle(e) {
    props.handleToggle && props.handleToggle(e, isActive());
    if (!!props.static) handleActiveState();
  };

  var isActive = function isActive() {
    return !!props.static ? active : props.active;
  };

  return _react.default.createElement("div", {
    className: "accordion ".concat(props.classes.accordion, " isActive-").concat(isActive())
  }, _react.default.createElement("div", {
    className: 'title'
  }, _react.default.createElement("div", {
    className: 'hotspot',
    onClick: handleToggle
  }), props.icon && _react.default.createElement("div", {
    className: 'iconography'
  }, _react.default.createElement(_index.Icon, {
    name: props.icon,
    animation: 'none'
  })), _react.default.createElement("div", {
    className: 'text'
  }, _react.default.createElement("div", {
    className: 'textinner',
    onClick: handleLink
  }, props.title)), _react.default.createElement("div", {
    className: 'indicator'
  }, _react.default.createElement(_index.Icon, {
    name: isActive() ? 'chevron-up' : 'chevron-down',
    animation: 'none'
  }))), _react.default.createElement("div", {
    className: 'contents'
  }, props.contents));
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(Accordion, _accordion_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = Accordion;
exports.default = _default;